<div class="w-full mb-8">
    <div class="grid grid-cols-4 gap-8">

        <mat-label class="flex items-center"> Installed Date </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput [matDatepicker]="picker" [(ngModel)]="data.installedDate" />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-label class="flex items-center"> Part Number </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput placeholder="" [(ngModel)]="data.partNo">
        </mat-form-field>

        <mat-label class="flex items-center"> Equipment Brand / OEM </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput placeholder="" [(ngModel)]="data.equipmentBrand">
        </mat-form-field>

        <mat-label class="flex items-center"> Size </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput placeholder="" type="number" [(ngModel)]="data.sizeIn">
            <span matTextSuffix>inches</span>
        </mat-form-field>

        <mat-label class="flex items-center"> Rating </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput placeholder="" type="number" [(ngModel)]="data.ratingPsi">
            <span matTextSuffix>psi</span>
        </mat-form-field>

        <div class="col-span-2"></div>

        <ng-container *ngIf="['annulusA','annulusB','annulusC','annulusD'].includes(formName)">
            <mat-label class="flex items-center"> AVR Installed </mat-label>
            <mat-radio-group [(ngModel)]="data.isAvrInstalled">
                <mat-radio-button [value]="true" class="mr-12" color="primary">Yes </mat-radio-button>
                <mat-radio-button [value]="false" color="primary">No</mat-radio-button>
            </mat-radio-group>

            <div class="col-span-2"></div>
        </ng-container>

        <mat-label class="flex items-center">Actuator Type </mat-label>
        <mat-radio-group class="col-span-2" [(ngModel)]="data.actuatorType">
            <mat-radio-button value="Pneumatic" color="primary" class="mr-2">Pneumatic </mat-radio-button>
            <mat-radio-button *ngIf="formName != 'ssv'" value="Manual" color="primary" class="mr-2">Manual</mat-radio-button>
            <mat-radio-button value="Hydraulic" color="primary">Hydraulic</mat-radio-button>
        </mat-radio-group>
    </div>

    <div class="grid grid grid-cols-4 gap-6 mt-6">
        <ng-container *ngIf="data.actuatorType == 'Pneumatic'">
            <mat-label class="flex items-center"> Actuator model </mat-label>
            <mat-form-field class="no-bottom-gap">
                <input matInput placeholder="" [(ngModel)]="data.actuatorModel">
            </mat-form-field>

            <div class="col-span-2"></div>

            <mat-label class="flex flex-col justify-center">
                <div> Opening </div>
                <div class="text-sm text-gray-700">(as per specification)
                </div>
            </mat-label>
            <div>
                <mat-form-field class="no-bottom-gap mb-3 w-full">
                    <input matInput placeholder="" type="number" [(ngModel)]="data.openingSec">
                    <span matTextSuffix>sec</span>
                </mat-form-field>
                <mat-form-field class="no-bottom-gap w-full">
                    <input matInput placeholder="" type="number" [(ngModel)]="data.openingCm">
                    <span matTextSuffix>cm</span>
                </mat-form-field>
            </div>

            <mat-label class="flex flex-col justify-center">
                <div> Closing </div>
                <div class="text-sm text-gray-700">(as per specification)
                </div>
            </mat-label>
            <div>
                <mat-form-field class="no-bottom-gap mb-3 w-full">
                    <input matInput placeholder="" type="number" [(ngModel)]="data.closingSec">
                    <span matTextSuffix>sec</span>
                </mat-form-field>
                <mat-form-field class="no-bottom-gap w-full">
                    <input matInput placeholder="" type="number" [(ngModel)]="data.closingCm">
                    <span matTextSuffix>cm</span>
                </mat-form-field>
            </div>
        </ng-container>

        <ng-container *ngIf="data.actuatorType == 'Manual'">
            <mat-label class="flex flex-col justify-center">
                <div>Fully Open</div>
                <div class="text-sm text-gray-700">(as per specification)</div>
            </mat-label>
            <mat-form-field class="no-bottom-gap w-full">
                <input matInput placeholder="" type="number" [(ngModel)]="data.fullyOpen">
                <span matTextSuffix>turns</span>
            </mat-form-field>

            <mat-label class="flex flex-col justify-center">
                <div>Fully Close</div>
                <div class="text-sm text-gray-700">(as per specification)</div>
            </mat-label>
            <mat-form-field class="no-bottom-gap w-full">
                <input matInput placeholder="" type="number" [(ngModel)]="data.fullyClose">
                <span matTextSuffix>turns</span>
            </mat-form-field>
        </ng-container>

        <ng-container *ngIf="data.actuatorType == 'Hydraulic'">
            <mat-label class="flex items-center">  Hydraulic return </mat-label>
            <mat-form-field class="no-bottom-gap w-full">
                <input matInput placeholder="" type="number" [(ngModel)]="data.hydraulicReturn">
                <span matTextSuffix>ml</span>
            </mat-form-field>
        </ng-container>

    </div>
</div>


<!-- <table class="w-full editTable">
    <tr>
        <td class="w-1/6 pb-7"> Installed Date </td>
        <td class="w-1/4">
            <mat-form-field class="w-9/12">
                <input matInput [matDatepicker]="picker" [(ngModel)]="data.installedDate" />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </td>

        <td class="w-1/4">
            <mat-form-field class="w-9/12">
                <input matInput placeholder="" [(ngModel)]="data.partNo">
            </mat-form-field>
        </td>
    </tr>
    <tr>
        <td class="pb-7"> Size </td>
        <td>
            <mat-form-field class="w-9/12">
                <input matInput placeholder="" type="number" [(ngModel)]="data.sizeIn">
                <span matTextSuffix>inches</span>
            </mat-form-field>
        </td>
    </tr>
    <tr>
        <td class="pb-7"> Equipment Brand / OEM </td>
        <td>
            <mat-form-field class="w-9/12">
                <input matInput placeholder="" [(ngModel)]="data.equipmentBrand">
            </mat-form-field>
        </td>
    </tr>
    <tr>
        <td class="pb-7"> Rating </td>
        <td>
            <mat-form-field class="w-9/12">
                <input matInput placeholder="" type="number" [(ngModel)]="data.ratingPsi">
                <span matTextSuffix>psi</span>
            </mat-form-field>
        </td>
    </tr>

    <ng-container *ngIf="formName != 'ssv'">
        <tr>
            <td> Type </td>
            <td class="pb-4">
                <mat-radio-group class="w-full mb-4" [(ngModel)]="data.type">
                    <mat-radio-button value="pneumatic" class="mr-4" color="primary">Pneumatic </mat-radio-button>
                    <mat-radio-button value="manual" color="primary">Manual</mat-radio-button>
                    <mat-radio-button value="hydraulic" color="primary">Hydraulic</mat-radio-button>
                </mat-radio-group>
            </td>
        </tr>
    </ng-container>

    <ng-container *ngIf="formName == 'annulusA'">
        <tr>
            <td> AVR Installed </td>
            <td class="pb-4">
                <mat-radio-group class="w-full mb-4" [(ngModel)]="data.isAvrInstalled">
                    <mat-radio-button [value]="true" class="mr-12" color="primary">Yes </mat-radio-button>
                    <mat-radio-button [value]="false" color="primary">No</mat-radio-button>
                </mat-radio-group>
            </td>
        </tr>
    </ng-container>

    <ng-container *ngIf="data.type == 'pneumatic'">
        <tr>
            <td class="pb-7"> Actuator model </td>
            <td>
                <mat-form-field class="w-9/12">
                    <input matInput placeholder="" [(ngModel)]="data.actuatorModel">
                </mat-form-field>
            </td>

            <td class="pb-7"> Opening <div class="text-sm text-gray-700">(as per specification)</div>
            </td>
            <td>
                <div>
                    <mat-form-field class="w-9/12">
                        <input matInput placeholder="" type="number" [(ngModel)]="data.openingSec">
                        <span matTextSuffix>sec</span>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field class="w-9/12">
                        <input matInput placeholder="" type="number" [(ngModel)]="data.openingCm">
                        <span matTextSuffix>cm</span>
                    </mat-form-field>
                </div>
            </td>
        </tr>

        <tr>
            <td class="pb-7"> Actuator type </td>
            <td>
                <mat-form-field class="w-9/12">
                    <input matInput placeholder="" [(ngModel)]="data.actuatorType">
                </mat-form-field>
            </td>

            <td class="pb-7"> Closing <div class="text-sm text-gray-700">(as per specification)</div>
            </td>
            <td>
                <div>
                    <mat-form-field class="w-9/12">
                        <input matInput placeholder="" type="number" [(ngModel)]="data.closingSec">
                        <span matTextSuffix>sec</span>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field class="w-9/12">
                        <input matInput placeholder="" type="number" [(ngModel)]="data.closingCm">
                        <span matTextSuffix>cm</span>
                    </mat-form-field>
                </div>
            </td>
        </tr>
        <tr>
            <td class="pb-7"> Hydraulic return </td>
            <td>
                <mat-form-field class="w-9/12">
                    <input matInput placeholder="" type="number" [(ngModel)]="data.hydraulicReturn">
                    <span matTextSuffix>ml</span>
                </mat-form-field>
            </td>
        </tr>
    </ng-container>

    <ng-container *ngIf="data.type == 'manual'">
        <tr>
            <td class="pb-7"> Fully Open <div class="text-sm text-gray-700">(as per specification)</div>
            </td>
            <td>
                <mat-form-field class="w-9/12">
                    <input matInput placeholder="" type="number" [(ngModel)]="data.fullyOpen">
                    <span matTextSuffix>turns</span>
                </mat-form-field>
            </td>

            <td class="pb-7"> Jammed </td>
            <td>
                <mat-form-field class="w-9/12">
                    <input matInput placeholder="" type="number" [(ngModel)]="data.jammed">
                    <span matTextSuffix>turns</span>
                </mat-form-field>
            </td>
        </tr>

        <tr>
            <td class="pb-7"> Fully Close <div class="text-sm text-gray-700">(as per specification)</div>
            </td>
            <td>
                <mat-form-field class="w-9/12">
                    <input matInput placeholder="" type="number" [(ngModel)]="data.fullyClose">
                    <span matTextSuffix>turns</span>
                </mat-form-field>
            </td>
        </tr>
    </ng-container>
</table> -->